import { forwardRef } from 'react';

import type React from 'react';

import type { LoadingButtonProps } from '@treneo/shared/ui';
import { LoadingButton } from '@treneo/shared/ui';

type SubmitButtonProps = LoadingButtonProps & {
  type?: 'submit' | 'button';
};

const SubmitButtonComponent = (
  { type = 'submit', onClick, ...props }: SubmitButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const isSubmitWithClick = type === 'submit' && onClick != null;
  const handleClick = isSubmitWithClick
    ? (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        onClick(e);
      }
    : onClick;
  return <LoadingButton ref={ref} type={type} onClick={handleClick} {...props} />;
};

SubmitButtonComponent.displayName = 'SubmitButton';

export const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(SubmitButtonComponent);
